import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { UserResponse, User } from '../interfaces/user.interface';
import { environment } from '../../app/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private apiUrl = environment.apiUrl;
    private organizationId : number | null = null;

    constructor(private http: HttpClient) {
        const orgInfo = localStorage.getItem('org_info');
        this.organizationId = orgInfo ? JSON.parse(orgInfo).id : null;
    }

    getUsers(): Observable<User[]> {
        return this.http.post<UserResponse>(`${this.apiUrl}/organizations/users/${this.organizationId}`, {}).pipe(
            map(response => response.data)
        );
    }
}